import { render, staticRenderFns } from "./dev-list-objects-vuetify.vue?vue&type=template&id=011c47ba"
import script from "./dev-list-objects-vuetify.vue?vue&type=script&lang=js"
export * from "./dev-list-objects-vuetify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports